import axios from 'axios'
// import qs from 'qs'
// eslint-disable-next-line no-unused-vars
import router from '@/router'
import Cookies from 'js-cookie'

import {
// eslint-disable-next-line no-unused-vars
  Message, MessageBox
} from 'element-ui'
// http://www.hbhxzb.com/hzjt-oa
// http://192.168.5.18:9099/hzjt-oa
var baseURL = process.env.VUE_APP_apiURL
axios.defaults.timeout = 5000
axios.defaults.baseURL = baseURL
export { baseURL }
// http request 拦截器
axios.interceptors.request.use(
  config => {
    // const webtoken = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    // config.data = qs.stringify(config.data)
    config.headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    config.headers['token'] = Cookies.get('webtoken') || ''
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.code !== 0) {
      if (response.data.code === 401) {
        if (router.history.current.path !== '/index') {
          localStorage.removeItem('webtoken')
          localStorage.removeItem('user')
          Cookies.remove('webtoken')
          MessageBox('您未登录或超时，请您重新登录！', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => {
            router.replace({
              path: '/'
            })
          })
        }
      } else {
        Message.error(response.data.msg)
      }
    }
    return response
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err)
      }
    )
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

// export function patch(url, data = {}) {
//   return new Promise((resolve, reject) => {
//     axios.patch(url, data).then(
//       response => {
//         resolve(response.data);
//       },
//       err => {
//         reject(err);
//       }
//     );
//   });
// }

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err)
      }
    )
  })
}
